import { render, staticRenderFns } from "./CheckedList.vue?vue&type=template&id=54741f15&"
import script from "./CheckedList.vue?vue&type=script&lang=js&"
export * from "./CheckedList.vue?vue&type=script&lang=js&"
import style0 from "./CheckedList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports